import React, { useState, useCallback, useEffect } from 'react';
import { Skeleton } from '@sravni/react-design-system';
import { useStyles, useBoolean, usePrevious } from '@sravni/react-utils';
import { URLS } from '../../constants/urls.js';
import { addParams } from '../../utils/addParams.js';
import '../../enums/MessageTypes.js';
import modules_1ba53a2f from './styles/GlobalSearch.module.less.js';

function GoogleResultList({ query, searchServiceHost }) {
    const cx = useStyles(modules_1ba53a2f);
    const [currentResultsPage, setCurrentResultsPage] = useState(0);
    const [isResultsLoading, setIsResultsLoading] = useBoolean(false);
    const prevQuery = usePrevious(query);
    const [resultItems, setResultItems] = useState([]);
    const requestGoogleResult = useCallback(async () => {
        const resultsUrl = new URL(URLS.SEARCH_RESULTS, searchServiceHost);
        const urlWithQuery = `${resultsUrl}?query=${encodeURIComponent(query)}&page=${currentResultsPage + 1}`;
        setIsResultsLoading.on();
        // TODO: Нужно вынести уровень общения по сети в отдельный слой(создать класс для работы с данными который под капотом спрячет способ получения данных)
        const data = await fetch(urlWithQuery, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'Content-Type': 'application/json',
            },
        }).then((response) => response.json());
        setResultItems((prev) => [...prev, ...data.items]);
        setIsResultsLoading.off();
        setCurrentResultsPage((prev) => prev + 1);
    }, [currentResultsPage, query, searchServiceHost, setIsResultsLoading, setCurrentResultsPage]);
    useEffect(() => {
        if (!query || prevQuery === query) {
            return;
        }
        requestGoogleResult();
    }, [query, requestGoogleResult, prevQuery]);
    const handleClassicalResultClick = useCallback((url) => {
        const resultUrl = addParams(url, query, true);
        window.open(resultUrl);
    }, [query]);
    if (!query) {
        return null;
    }
    return (React.createElement("div", { className: cx(modules_1ba53a2f.resultsContent) },
        React.createElement("div", { className: cx(modules_1ba53a2f.resultsTitle) },
            React.createElement("b", null, "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043F\u043E\u0438\u0441\u043A\u0430"),
            " ",
            React.createElement("span", { className: cx(modules_1ba53a2f.resultsQuery) },
                "\"",
                query,
                "\"")),
        resultItems?.map((item) => (React.createElement("div", { className: cx(modules_1ba53a2f.resultItem), key: item.link },
            React.createElement("div", { onClick: () => handleClassicalResultClick(item.link), className: cx(modules_1ba53a2f.resultTitle) }, item.title),
            React.createElement("div", { className: cx(modules_1ba53a2f.resultDescription) }, item.snippet)))),
        resultItems.length <= 0 && !isResultsLoading ? (React.createElement("p", null,
            "\u041F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 ",
            React.createElement("span", { className: cx(modules_1ba53a2f.resultsQuery) },
                "\"",
                query,
                "\""),
            " \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E")) : null,
        isResultsLoading && (React.createElement(Skeleton, null,
            React.createElement(Skeleton.Paragraph, null),
            React.createElement(Skeleton.Paragraph, { width: 50 }))),
        resultItems.length > 0 && !isResultsLoading ? (React.createElement("div", { className: cx(modules_1ba53a2f.resultItem) },
            React.createElement("div", { onClick: requestGoogleResult, className: cx(modules_1ba53a2f.moreLabel) }, "\u041F\u041E\u041A\u0410\u0417\u0410\u0422\u042C \u0415\u0429\u0401"))) : null));
}

export { GoogleResultList };
//# sourceMappingURL=GoogleResultList.js.map
